export class AnalyticsEvent {
  // predefined
  public static readonly LOGIN = 'login';
  // order
  public static readonly TASK_LIST_LOAD = 'task_list_load';
  public static readonly TASK_LIST_ORDER_CHANGE = 'task_list_order_change';
  // custom
  public static readonly IFA_LOGIN_USING_NFC = 'ifa_login_using_nfc';
  public static readonly IFA_LOGIN = 'ifa_login';
}
